// @flow
import { Base64 } from 'js-base64';

import type { Product } from '../duck';

export const encodeProduct = (p: Product) => {
  const a: any = {
    url: p.url,
    amount: p.amount,
    detail: p.detail || '',
    name: p.name,
    price: p.price,
    weight: p.weight,
    image: p.image,
    originalPackaging: !!p.originalPackaging,
  };
  if (!!p.category) {
    a.categoryId = p.category.id;
  }else if (typeof p.categoryId === 'number') {
    a.categoryId = p.categoryId;
  }
  if (!!p.volumeTier) {
    a.volumeTier = p.volumeTier.code;
  }
  if (!!p.onlineStore) {
    a.onlineStore = p.onlineStore;
  }
  return Base64.encode(JSON.stringify(a));
};



// WEBPACK FOOTER //
// ./src/modules/featured-products/utils/encode.js